module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// C:/Users/brendanj/source/repos/projekteyt/ProjekteYtPortal/ClientApp/node_modules/babel-runtime/regenerator/index.js
// module id = 63
// module chunks = 0